<script setup lang="ts">
import {Icon} from '@iconify/vue';
import type {PartInfo} from '@/generated';

// Dedizierte Part-Auswahl NUR für die Transposition (Manual-Intervall). Bewusst getrennt von
// PartSelection.vue (das an settings.selected_parts = Convert-Scope gebunden ist): Der zu
// transponierende Part-Umfang darf sich NICHT mit den zu konvertierenden Stimmen vermischen.
// Leere Auswahl = ganzer Score (bisheriges Transpositions-Verhalten).
const {parts = []} = defineProps<{ parts?: PartInfo[] }>();

const selected = defineModel<number[]>('selected', {default: () => []});

function clefLabel(clef: string | null | undefined): string | null {
  switch (clef) {
    case 'F':
      return 'Bass';
    case 'G':
      return 'Violin';
    case 'C':
      return 'Alt';
    default:
      return clef ?? null;
  }
}

function togglePart(index: number) {
  const current = selected.value;
  selected.value = current.includes(index)
      ? current.filter((i) => i !== index)
      : [...current, index];
}
</script>

<template>
  <div v-if="parts.length > 1" class="rounded-xl border border-gray-100 bg-white/60 p-3">
    <div class="flex items-center gap-1.5 mb-2 text-sm font-medium text-gray-700">
      <Icon icon="fa6-solid:layer-group" class="text-gray-400"/>
      Nur bestimmte Stimme(n) transponieren
      <span class="text-xs font-normal text-gray-400">(leer = ganzer Score)</span>
    </div>
    <div class="grid sm:grid-cols-2 gap-1">
      <label
          v-for="part in parts"
          :key="part.index"
          class="flex items-center gap-2 text-sm px-2 py-1 rounded-lg border border-transparent hover:bg-gray-50 hover:border-gray-100 cursor-pointer transition-colors"
      >
        <input
            type="checkbox"
            :value="part.index"
            :checked="selected.includes(part.index)"
            @change="togglePart(part.index)"
        />
        <span class="text-gray-700">
          {{ part.name }}
          <span v-if="clefLabel(part.clef)" class="text-xs text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded">
            {{ clefLabel(part.clef) }}
          </span>
          <span v-if="part.instrument" class="text-xs text-gray-400">({{ part.instrument }})</span>
        </span>
      </label>
    </div>
  </div>
</template>
